var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame11712770321(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.69043,
    width: 36.8203,
    height: 38,
    rx: 12,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6006 10C15.9836 10 13.8545 12.1291 13.8545 14.7461C13.8545 17.3631 15.9836 19.4922 18.6006 19.4922C21.2176 19.4922 23.3467 17.3631 23.3467 14.7461C23.3467 12.1291 21.2176 10 18.6006 10Z",
    fill: "url(#paint0_linear_3390_1091)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6006 10C15.9836 10 13.8545 12.1291 13.8545 14.7461C13.8545 17.3631 15.9836 19.4922 18.6006 19.4922C21.2176 19.4922 23.3467 17.3631 23.3467 14.7461C23.3467 12.1291 21.2176 10 18.6006 10Z",
    fill: "url(#paint1_linear_3390_1091)",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5056 22.5928C23.2063 21.2734 21.4837 20.5469 19.6553 20.5469H17.5459C15.7175 20.5469 13.9949 21.2734 12.6955 22.5928C11.4025 23.9057 10.6904 25.6387 10.6904 27.4727C10.6904 27.7639 10.9265 28 11.2178 28H25.9834C26.2746 28 26.5107 27.7639 26.5107 27.4727C26.5107 25.6387 25.7987 23.9057 24.5056 22.5928Z",
    fill: "url(#paint2_linear_3390_1091)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5056 22.5928C23.2063 21.2734 21.4837 20.5469 19.6553 20.5469H17.5459C15.7175 20.5469 13.9949 21.2734 12.6955 22.5928C11.4025 23.9057 10.6904 25.6387 10.6904 27.4727C10.6904 27.7639 10.9265 28 11.2178 28H25.9834C26.2746 28 26.5107 27.7639 26.5107 27.4727C26.5107 25.6387 25.7987 23.9057 24.5056 22.5928Z",
    fill: "url(#paint3_linear_3390_1091)",
    fillOpacity: 0.29
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6006 10C16.9836 10 14.8545 12.1291 14.8545 14.7461C14.8545 17.3631 16.9836 19.4922 19.6006 19.4922C22.2176 19.4922 24.3467 17.3631 24.3467 14.7461C24.3467 12.1291 22.2176 10 19.6006 10Z",
    fill: "url(#paint4_linear_3390_1091)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5056 22.5928C24.2063 21.2734 22.4837 20.5469 20.6553 20.5469H18.5459C16.7175 20.5469 14.9949 21.2734 13.6955 22.5928C12.4025 23.9057 11.6904 25.6387 11.6904 27.4727C11.6904 27.7639 11.9265 28 12.2178 28H26.9834C27.2746 28 27.5107 27.7639 27.5107 27.4727C27.5107 25.6387 26.7987 23.9057 25.5056 22.5928Z",
    fill: "url(#paint5_linear_3390_1091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3390_1091",
    x1: 20.802,
    y1: 7.00585,
    x2: 17.6246,
    y2: 19.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3390_1091",
    x1: 18.6006,
    y1: 9.95457,
    x2: 18.6006,
    y2: 19.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3390_1091",
    x1: 22.2695,
    y1: 18.1959,
    x2: 21.0346,
    y2: 28.3919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3390_1091",
    x1: 18.6006,
    y1: 20.5112,
    x2: 18.6006,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3390_1091",
    x1: 21.802,
    y1: 7.06534,
    x2: 18.6529,
    y2: 19.3727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3390_1091",
    x1: 23.2695,
    y1: 18.2426,
    x2: 22.0462,
    y2: 28.3914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame11712770321);
export default __webpack_public_path__ + "static/media/Frame 1171277032 (1).3233ccbcd69092a2af0e8a43121ec0dd.svg";
export { ForwardRef as ReactComponent };